import { render, staticRenderFns } from "./switchButtons.vue?vue&type=template&id=6ee29160&"
import script from "./switchButtons.vue?vue&type=script&lang=js&"
export * from "./switchButtons.vue?vue&type=script&lang=js&"
import style0 from "./switchButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports